export default class EmergoRequest {
  public prompt_uuid = crypto.randomUUID() // unique identifier for this prompt item
  public unixtimestamp = new Date().getTime() // unix timestamp
  public name_ui_view = '' // the view / page / "spinne" of the clavis web-ui (for now only "kernbotschaften" available)
  public context_view = '' // information of all items of the particular view
  public name_view_item = '' // the item for which the a proposed text is generated (e.g. "customer_a" receives a kernbotschaft)
  public context_item = '' // information of this specific item (keywords, past responses, etc.)
  public target_audience = '' // information about the target audience how will look at
  public tags: string[] = [] // tags for the item (potentially interesting for future expansion of the software)
  public response_style = '' // "informative" vs "reactive"
  public response = '' // placeholder for the response that will be generated
  public response_json: EmergoResponse = new EmergoResponse() // placeholder for the response that will be generated
  public respones_quality = {} // placeholder for the response that will be generated
  public response_ideal = '' // placeholder for the response that will be generated

  public tagOptions = ['kernbotschaft']
  public styleOptions = ['informative', 'reactive']
  public targetAudienceOptions = [
    'Fachöffentlichkeit/Fachexpert:innen',
    'Formierte Bürger:innen (im Sinne von Bürgerinitiativen o.ä.)',
    'Bevölkerung',
    'Anrainer:innen',
    'Wirtschaft (Unternehmen & Organisationen)',
    'Gemeinde',
    'Bildung',
    'Öffentliche Einrichtungen (Verwaltung, Gesundheit, Kultur etc.)',
    'Region',
    'Medien',
    'NGOs',
    'Politik',
    'Interessensvertretung/Verein',
    'Sonstige',
  ]

  constructor(
    name_ui_view: string,
    context_view: string,
    name_view_item: string,
    context_item: string,
    target_audience: string,
    tags: string[],
    response_style: string,
  ) {
    this.name_ui_view = name_ui_view
    this.context_view = context_view
    this.name_view_item = name_view_item
    this.context_item = context_item
    this.target_audience = target_audience
    this.tags = tags
    this.response_style = response_style
  }
}

class EmergoResponse {
  public open_ai_turbo = ''
  public open_ai_4 = ''
  public mistral_small = ''
  public mistral_medium = ''
}
